{
    "Number": "Nein",
    "Starttime": "Startzeit",
    "From": "Aus",
    "To": "Zu",
    "Duration": "Dauer",
    "NAME": "CallRecording"
}